import { API_BASIC_URL_USER_MANAGEMENT } from "../config/constants";
import { handleError, handleResponse } from "./ApiUtils";
import Fetch from "./Fetch";


export const createUser = (userData) => {
  return Fetch.create(`${API_BASIC_URL_USER_MANAGEMENT}/api/v1/user`, userData).then(handleResponse).catch(handleError);
};

export const fetchUserRecordList = (data) => {
  return Fetch.get(`${API_BASIC_URL_USER_MANAGEMENT}/api/v1/users`, data).then(handleResponse).catch(handleError);
};

export const getUserDetails = (toUpdateUserId) => {
  return Fetch.get(`${API_BASIC_URL_USER_MANAGEMENT}/api/v1/user/${toUpdateUserId}`).then(handleResponse).catch(handleError);
}

export const updateUser = (userData) => {
  return Fetch.update(`${API_BASIC_URL_USER_MANAGEMENT}/api/v1/user`, userData).then(handleResponse).catch(handleError);
};